import React, { useState } from "react";
import "./Accordion.scss";
import { Icon } from "@iconify/react";
import Buttons from "../ui/button/Buttons";

const Accordion = ({
  title,
  buttonLabel,
  accordion = true,
  button = true,
  children,
  clickEvent = ()=>{},
  isDisable,
  headerActions            
}) => {
  const [isOpen, setIsOpen] = useState(accordion ? false : true);

  return (
    <div className={`accordion-card ${accordion ? "accordion-enabled" : "card-mode"}`}>
      <div className="accordion-header" onClick={(e)=>accordion ?setIsOpen(!isOpen) :e.stopPropagation() }>
        <h3 className="accordion-title">{title}</h3>

        <div className="header-actions">
          {headerActions && (
            <div className="d-flex gap-2" onClick={(e) => e?.stopPropagation()}>
              {headerActions}
            </div>
          )}
          {button && (
            <Buttons
              buttonText={buttonLabel}
              buttonTypeClassName="success-btn"
              onClick={(e) => (e.stopPropagation(), clickEvent(e))}
              isDisable={isDisable}
            />
          )}
          {accordion && (
            <span
              className="accordion-toggle"
              onClick={() => setIsOpen(!isOpen)}
            >
              <Icon
                icon={isOpen ? "mdi:minus" : "mdi:plus"}
                width={20}
                height={20}
              />
            </span>
          )}
        </div>
      </div>

      {/* Accordion Content */}
      {(!accordion || isOpen) && (
        <div className="accordion-content">{children}</div>
      )}
    </div>
  );
};

export default Accordion;
